/**
 * Styled Components - Created by jorge on 10/08/18.
 */
import styled from 'styled-components'
import AntDivider from 'antd/lib/divider'
import DragScrollContainer from '../DragScrollContainer'

export const Container = styled.div`
  position: relative;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
`

export const Title = styled.div`
  text-align: center;
  margin-top: ${({ secondary }: { secondary?: boolean}) => secondary ? '12px' : '48px'};
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.93px;
  line-height: 18px;
`
export const Divider = styled(AntDivider)`
  display: block;
  margin: 8px 10%;
  width: auto;
  min-width: 20px;
`
export const ProductsContainer = styled(DragScrollContainer)`
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  white-space: nowrap;
  gap: var(--spacing-16);
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  &[data-centered="true"] {
    justify-content: center;
  }
  .related-items {
    min-width: 250px;
    max-width: 312px;
    width: 100%;
    :first-child {
      margin-left: max(4.5rem, calc((100vw - 1296px) / 2));
    }
    :last-child {
      margin-right: max(4.5rem, calc((100vw - 1296px) / 2));
    }
  }
  .design-item {
    max-width: 324px;
    min-width: 324px;
    border: var(--border-regular) solid var(--neutral-border-light);
  }
  section {
    margin: 0px 40px 0px 0px;
  }

  @media (max-width: 768px) {
    &[data-centered="true"] {
      justify-content: flex-start;
    }
  }

  @media (max-width: 768px) {
    .related-items:first-child {
      margin-left: max(1.5rem, 3vw);
    }
    .related-items:last-child {
      margin-right: max(1.5rem, 3vw);
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {
    section {
      width: 220px;
      min-width: 170px;
    }
  }
`

export const FooterDesign = styled.div`
  padding: var(--spacing-12) var(--spacing-16);
  .name { 
    overflow: hidden;
    color: var(--neutral-darkest);
    text-overflow: ellipsis;
    font: 600 16px/22px var(--font-barlow);
    letter-spacing: -0.1px;
  }
  .description {
    overflow: hidden;
    color: var(--neutral-secondary);
    text-overflow: ellipsis;
    font: 400 12px/20px var(--font-inter);
    margin-top: var(--spacing-2);
  }
  .code {
    color: var(--neutral-muted);
    font: 600 12px/18px var(--font-barlow);
    letter-spacing: 1px;
    text-transform: uppercase;
    border-bottom: var(--border-regular) solid var(--neutral-border-light);
    padding-bottom: 12px;
    margin-bottom: 20px;
  }
  .priceLabel {
    color: var(--neutral-darkest);
    font: 600 16px/22px var(--font-barlow);
    letter-spacing: -0.1px;
  }
  .qtyLabel {
    color: var(--neutral-muted);
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/RelatedProducts/styledComponents.tsx